import React from 'react';
import CustomerMyBusinessByCustomerList from './CustomerMyBusinessByCustomerList';
import { CRM_COMM_PAGE_MY_ACQUISITION_BY_CUSTOMER_DETAIL_ACQUISITIONS } from '../../utils/crmCommunicationTableColumns';

export const CRM_MY_ACQUISITION_MASK_BY_CUSTOMER = 'cust031';
export const CRM_MY_ACQUISITION_MASK_DETAIL = 'cust032';

/** Moje akvizície → Podľa zákazníka (cust031). */
export default function CustomerMyAcquisitionByCustomerList(props) {
  return (
    <CustomerMyBusinessByCustomerList
      {...props}
      mode="acquisitions"
      pageListKey="CustomerMyAcquisitionByCustomerList"
      pageAddKey="CustomerMyAcquisitionByCustomerDetail"
      maskAdd={CRM_MY_ACQUISITION_MASK_DETAIL}
      endpointBase="/api/customer_evaluations/my_acquisitions/by_customer"
      embeddedListPageKey={CRM_COMM_PAGE_MY_ACQUISITION_BY_CUSTOMER_DETAIL_ACQUISITIONS}
    />
  );
}
